import { useContext, useMemo } from "react";
import { FeatureFlagKey } from "../feature-flags";
import { FeatureFlagContext } from "../providers/feature-flags-provider";
import { useStateContext } from "state";

export const useFeatureFlag = (key: FeatureFlagKey): boolean => {
  const flags = useContext(FeatureFlagContext);
  const state = useStateContext();

  const userOrganizationId = state.user?.organizationId;
  const flag = flags[key];

  const isEnabled = useMemo(() => {
    return (
      flag.isEnabled &&
      (flag.organizationIds.length === 0 ||
        flag.organizationIds.some((id) => id === userOrganizationId))
    );
  }, [userOrganizationId, flag]);

  return isEnabled;
};
